import cx from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import * as _ from 'lodash'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import AddIcon from '@mui/icons-material/Add'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Button, Stack, Typography, IconButton } from '@mui/material'

import {
  deleteKnowledgeGroup,
  getAllModulesSubgroups,
  updateKnowledgeGroup,
} from '@/store/knowledge/actions'
import { HelperService } from '@/services/helper.service'

import MoveSelectedModal from '@/components/UI/KnowledgeDatatableComponent/MoveSelectedModal'
import PermissionWrapper from '@/components/UI/PermissionWrapper/PermissionWrapper'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import BasicModal from '@/components/UI/Dialog'
import UpdateGroupModal from '@/components/UI/KGroupsTree/UpdateGroupModal'

import deleteDisable from '@/assets/images/delete-black.svg'
import deleteRed from '@/assets/images/delete-red.svg'
import moveIcon from '@/assets/images/move-icon.svg'
import blackMoveIcon from '@/assets/images/disable-move-icon.svg'
import nestImg from '@/assets/New-images/nest-group-img.svg'
import unnestImg from '@/assets/New-images/unnest-group-img.svg'
import NestDisable from '@/assets/New-images/nest-disable-img.svg'
import unnestDisable from '@/assets/New-images/unnest-disable-img.svg'
import './index.scss'

const helperService = new HelperService()

export default function ManageKnowledgeGroup() {
  const { t } = useTranslation('translation')
  const dispatch = useDispatch()
  const [flatGroups, setFlatGroups] = useState([])
  const [expandedGroups, setExpandedGroups] = useState([])
  const [selectedGroupIds, setSelectedGroupIds] = useState<string[]>([])
  const [isOpenMove, setIsOpenMove] = useState(false)

  // Modal state for add/edit group
  const [showUpdateGroupModal, setShowUpdateGroupModal] = useState(false)
  const [editingGroup, setEditingGroup] = useState<{
    _id?: string
    parent_id?: string
    name?: string
    topic?: string
    editMode: boolean
  }>({ editMode: false })

  useEffect(() => {
    getAllYearsFun()
  }, [])

  useEffect(() => {
    if (!selectedGroupIds) {
      setIsUnnestDisable(true)
      setIsNestDisable(true)
      return
    } else {
      selectedGroupActions()
    }
  }, [selectedGroupIds])

  const [moveToIdUnnest, setMoveToIdUnnest] = useState(null)
  const [moveToIdNest, setMoveToIdNest] = useState(null)
  const [isUnnestDisable, setIsUnnestDisable] = useState(true)
  const [isNestDisable, setIsNestDisable] = useState(true)

  const selectedGroupActions = () => {
    setIsUnnestDisable(true)
    setIsNestDisable(true)
    if (
      flatGroups &&
      flatGroups.length > 0 &&
      selectedGroupIds &&
      selectedGroupIds.length > 0
    ) {
      const groups = flatGroups.filter((e: any) => {
        return selectedGroupIds.some((item: any) => {
          return e._id === item
        })
      })
      const group = _.groupBy(groups, 'parent_id')
      const getGroup = (val: any) => {
        return flatGroups.find(e => e._id === val)
      }
      const unnestFunc = (groupObj: any) => {
        if (Object.keys(groupObj).length > 1) {
          setIsUnnestDisable(true)
          return
        } else {
          for (const key in groupObj) {
            const moveTo = getGroup(key)

            if (key === 'null') {
              setIsUnnestDisable(true)
              return
            } else {
              setIsUnnestDisable(false)
              setMoveToIdUnnest(moveTo && moveTo.parent_id)
              return
            }
          }
        }
      }
      unnestFunc(group)
      const nestFunc = (groupObj: any) => {
        if (Object.keys(groupObj).length > 1) {
          setIsNestDisable(true)
          setMoveToIdNest(null)
          return
        } else {
          const onSetNestBtn = (groups: any) => {
            let newParent: any = null
            let i: number = 0
            let selectedIndex = null
            for (let index = 0; index < groups.length; index++) {
              const element = groups[index]
              const selected = selectedGroupIds.filter(
                (i: any) => i === element?._id,
              )
              if (selectedIndex === 0) {
                newParent = null
                break
              } else if (selectedIndex >= 1 && selectedIndex !== null) {
                if (
                  groups[selectedIndex + 1]._id !== groups[index]._id &&
                  selected &&
                  selected.length > 0
                ) {
                  if (selectedGroupIds && selectedGroupIds.length > 1) {
                    newParent = null
                  } else {
                    newParent = newParent
                  }
                  break
                } else {
                  if (selected && selected.length > 0) {
                    if (newParent) {
                      if (i < index) {
                        newParent = groups[i - 1]
                        selectedIndex = index
                      }
                    }
                  }
                }
              } else {
                if (selected && selected.length > 0) {
                  newParent = index - 1 < 0 ? null : groups[index - 1]
                  i = index
                  selectedIndex = index
                }
              }
            }
            if (newParent === null) {
              setIsNestDisable(true)
              setMoveToIdNest(null)
              return
            } else {
              setMoveToIdNest(newParent?._id)
              setIsNestDisable(false)
              return
            }
          }
          for (const Key in groupObj) {
            if (Key === 'null') {
              const groups = flatGroups.filter((i: any) => i.parent_id === null)
              if (groups && groups.length > 1) {
                onSetNestBtn(groups)
              }
            } else {
              const moveTo = getGroup(Key)
              if (moveTo && moveTo.children && moveTo.children.length > 1) {
                onSetNestBtn(moveTo.children)
              }
            }
          }
        }
      }
      nestFunc(group)
    } else {
      setMoveToIdNest(null)
      setMoveToIdUnnest(null)
    }
  }

  const getAllYearsFun = async () => {
    try {
      const response: any = await dispatch(getAllModulesSubgroups())
      const arr = response.filter((g: any) => g.group_type !== 'system')
      if (arr && arr.length > 0) {
        setFlatGroups(_.uniqBy(arr, '_id'))
      } else {
        setFlatGroups([])
      }
    } catch (error: any) {
      setFlatGroups([])
    }
  }

  const [deleteModuleModalShow, setDeleteModuleModalShow] = useState(false)
  const [deletedModuleId, setDeletedModuleId] = useState([])
  const deleteModuleModalHandler = () => {
    setDeleteModuleModalShow(!deleteModuleModalShow)
  }
  const confirmDeleteModuleHandler = async (deleteId: string[]) => {
    setDeleteModuleModalShow(false)
    if (deleteId.length === flatGroups.length) {
      helperService.showToaster(
        'You cannot delete the last knowledge group. Minimum of 1 knowledge group is required.',
        'error',
      )
      return
    }

    let successCount = 0
    let failedCount = 0
    const failedGroups: string[] = []

    for (let index = 0; index < deleteId.length; index++) {
      const element = deleteId[index]
      try {
        await dispatch(deleteKnowledgeGroup(element))
        successCount++
      } catch (error: any) {
        failedCount++
        failedGroups.push(element)
        console.log('error deleting group:', element, error)
      }
    }

    // Show appropriate message based on results
    if (successCount > 0 && failedCount === 0) {
      helperService.showToaster(
        successCount === 1
          ? t('Knowledge group has been deleted')
          : t('Knowledge groups have been deleted'),
        'success',
      )
    } else if (successCount > 0 && failedCount > 0) {
      helperService.showToaster(
        t(
          `${successCount} group(s) deleted successfully. ${failedCount} group(s) failed to delete.`,
        ),
        'warning',
      )
    } else if (failedCount > 0) {
      helperService.showToaster(
        t('Failed to delete knowledge group(s)'),
        'error',
      )
    }

    getAllYearsFun()
    deleteModuleModalHandler()
    setSelectedGroupIds([])
  }

  const addOrRemove = (groups: any, id: string) => {
    if (groups.find((gID: any) => gID === id)) {
      return groups.filter((gID: any) => gID !== id)
    } else {
      groups.push(id)
      return groups
    }
  }

  const toggleGroup = (g: any) => {
    const copy = [...flatGroups]
    let copyExpaned = [...expandedGroups]

    copy.forEach((group: any) => {
      if (group._id === g._id) {
        g.isExpand = !g.isExpand
        copyExpaned = addOrRemove(copyExpaned, g._id)
      }
    })
    setExpandedGroups(copyExpaned)

    setFlatGroups(copy)
  }

  const isShowExpand = (g: any) => {
    return !!(g?.children && g?.children.length > 0)
  }

  const isExpanded = (gId: any) => {
    return expandedGroups.find(id => id === gId)
  }

  const isShown = (g: any) => {
    if (!g.parent_id) {
      return true
    }
    const parent = flatGroups.find((group: any) => group._id === g.parent_id)
    if (
      expandedGroups.find((eg: any) => eg === parent._id) &&
      isShown(parent)
    ) {
      return true
    }

    return false
  }

  const moveGroups = async (groupIds: string[], moveToId: string) => {
    if (!groupIds || groupIds.length === 0) return
    let movedCount = 0
    for (const groupId of groupIds) {
      // Skip if target parent is the same as current group id
      if (groupId === moveToId) continue
      await dispatch(updateKnowledgeGroup({ parent_id: moveToId }, groupId))
      movedCount++
    }

    getAllYearsFun()
    if (movedCount === 1) {
      helperService.showToaster(t('Knowledge group has been moved'), 'success')
    } else if (movedCount > 1) {
      helperService.showToaster(
        t('Knowledge groups have been moved'),
        'success',
      )
    }

    setSelectedGroupIds([])
  }

  const onSelectKnowledgeGroup = (e: any, id: any) => {
    let temp = [...selectedGroupIds]
    if (e.target.checked) {
      const isPresent = temp.indexOf(id)
      if (isPresent < 0) {
        temp.push(id)
      }
    } else {
      let data = [...selectedGroupIds]
      let index = data.indexOf(id)
      data.splice(index, 1)
      temp = [...data]
    }

    setSelectedGroupIds([..._.uniq(temp)])
  }

  const onSelectAllGroups = (e: any) => {
    if (e.target.checked) {
      if (flatGroups && flatGroups.length > 0) {
        let data: any[] = [...flatGroups.map(e => e._id)]
        setSelectedGroupIds([..._.uniq(data)])
      }
    } else {
      setSelectedGroupIds([])
    }
  }

  // Modal helpers
  const openAddGroup = (g: any) => {
    setEditingGroup({
      parent_id: g ? g._id : null,
      editMode: false,
    })
    setShowUpdateGroupModal(true)
  }

  const openEditGroup = (g: any) => {
    setEditingGroup({
      _id: g._id,
      name: g.name,
      topic: g.topic,
      parent_id: g.parent_id,
      editMode: true,
    })
    setShowUpdateGroupModal(true)
  }

  return (
    <section className="page-mid-wraper h-without-foter">
      <BasicModal
        open={deleteModuleModalShow}
        onClose={deleteModuleModalHandler}
        showCloseButton
        sx={{ p: 2, width: 480, height: 'auto' }}
        title={t('Are you sure you want to delete?')}
      >
        <Typography variant="body3">
          {t(
            'Knowledge group(s) and any nested group(s) would be permanently deleted. All knowledge items / activities in knowledge group(s) would be shifted to Uncategorised',
          )}
        </Typography>
        <Stack direction="row" justifyContent="flex-end" spacing={1.5} pt={1}>
          <Button variant="outlined" onClick={deleteModuleModalHandler}>
            {t('No, Cancel')}
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => confirmDeleteModuleHandler(deletedModuleId)}
          >
            {t('Yes, Delete')}
          </Button>
        </Stack>
      </BasicModal>

      <MoveSelectedModal
        title={t('Move selected group(s) to')}
        show={isOpenMove && flatGroups && flatGroups.length > 0}
        onHide={() => setIsOpenMove(false)}
        initialSelectedGroupId={
          selectedGroupIds.length > 0 ? selectedGroupIds[0] : null
        }
        confirmCategoryUpdate={moveToId => {
          setIsOpenMove(false)
          moveGroups(selectedGroupIds, moveToId)
        }}
      />

      {/* Add/Edit Group Modal */}
      <UpdateGroupModal
        show={showUpdateGroupModal}
        _id={editingGroup._id}
        parent_id={editingGroup.parent_id}
        name={editingGroup.name}
        topic={editingGroup.topic}
        editMode={editingGroup.editMode}
        onHide={() => setShowUpdateGroupModal(false)}
        confirmHandler={() => {
          setShowUpdateGroupModal(false)
          getAllYearsFun()
        }}
      />

      <div>
        <ChildPageHeader
          title={t('Manage Knowledge Groups')}
          subTitle={t('Add, edit, or remove knowledge groups here')}
        />
        <div className="knowledge-viewby">
          <PermissionWrapper>
            <div className="d-flex mb-2 justify-content-between mb-3">
              <div>
                <button
                  className={cx(
                    'btn btn-link  py-0 font-weight-normal font-sm',
                    {
                      'clr-blue':
                        selectedGroupIds && selectedGroupIds.length > 0,
                    },
                  )}
                  disabled={
                    !selectedGroupIds ||
                    (selectedGroupIds && selectedGroupIds.length <= 0)
                  }
                  onClick={() => setIsOpenMove(true)}
                >
                  <img
                    src={
                      !selectedGroupIds ||
                      (selectedGroupIds && selectedGroupIds.length <= 0)
                        ? blackMoveIcon
                        : moveIcon
                    }
                    className="mr-2"
                    alt={t('Delete')}
                    width="16"
                    height="16"
                  />
                  {t('Move Selected')}
                </button>
                <button
                  className={cx(
                    'btn btn-link  py-0 font-weight-normal font-sm',
                    {
                      'clr-blue':
                        !!selectedGroupIds &&
                        selectedGroupIds.length > 0 &&
                        !isNestDisable,
                    },
                  )}
                  disabled={
                    selectedGroupIds &&
                    (selectedGroupIds.length <= 0 || isNestDisable)
                  }
                  onClick={() => {
                    moveGroups(selectedGroupIds, moveToIdNest)
                  }}
                >
                  <img
                    src={
                      selectedGroupIds &&
                      (selectedGroupIds.length <= 0 || isNestDisable)
                        ? NestDisable
                        : nestImg
                    }
                    className="mr-2"
                    alt={t('Move Down')}
                    width="16"
                    height="16"
                  />
                  {t('Nest Selected')}
                </button>
                <button
                  className={cx(
                    'btn btn-link  py-0 font-weight-normal font-sm',
                    {
                      'clr-blue':
                        !!selectedGroupIds &&
                        selectedGroupIds.length > 0 &&
                        !isUnnestDisable,
                    },
                  )}
                  disabled={
                    selectedGroupIds &&
                    (selectedGroupIds.length <= 0 || isUnnestDisable)
                  }
                  onClick={() => {
                    moveGroups(selectedGroupIds, moveToIdUnnest)
                  }}
                >
                  <img
                    src={
                      selectedGroupIds &&
                      (selectedGroupIds.length <= 0 || isUnnestDisable)
                        ? unnestDisable
                        : unnestImg
                    }
                    className="mr-2"
                    alt={t('Move Down')}
                    width="16"
                    height="16"
                  />
                  {t('Un-nest Selected')}
                </button>
                <button
                  className={cx(
                    'btn btn-link  py-0 font-weight-normal font-sm',
                    {
                      'clr-red':
                        selectedGroupIds && selectedGroupIds.length > 0,
                    },
                  )}
                  disabled={selectedGroupIds && selectedGroupIds.length <= 0}
                  onClick={() => {
                    setDeletedModuleId(selectedGroupIds)
                    setDeleteModuleModalShow(true)
                  }}
                >
                  <img
                    src={
                      selectedGroupIds && selectedGroupIds.length <= 0
                        ? deleteDisable
                        : deleteRed
                    }
                    className="mr-2"
                    alt={t('Delete')}
                    width="16"
                    height="16"
                  />
                  {t('Delete Selected')}
                </button>
              </div>
              <div>
                <Button variant="contained" onClick={() => openAddGroup(null)}>
                  {t('+ New Group')}
                </Button>
              </div>
            </div>
          </PermissionWrapper>

          <div className="p-0 mb-4">
            <div>
              <div className="groups-tree tw-border tw-rounded-2xl tw-shadow-md">
                <table className="w-100 groups-table">
                  <colgroup>
                    <col style={{ width: 10 }} />
                    <col style={{ width: '40%' }} />
                    <col style={{ width: '40%' }} />
                    <col style={{ width: '15%' }} />
                  </colgroup>
                  <thead>
                    <tr className="justify-content-between align-items-center px-3 py-3 bg-grey-head manage-knowledge-header">
                      <th style={{ width: 10 }}>
                        <input
                          type="checkbox"
                          className="mr-2"
                          checked={
                            selectedGroupIds.length === flatGroups.length
                          }
                          onChange={e => onSelectAllGroups(e)}
                        />
                      </th>
                      <th>{t('Display name')}</th>
                      <th>{t('Topic')}</th>
                      <th className="text-center">{t('Actions')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {flatGroups.map(
                      (g: any) =>
                        (isShown(g) || g.depth === 0) && (
                          <tr
                            key={g._id}
                            className={`groups-item ${
                              selectedGroupIds &&
                              selectedGroupIds.find((e: any) => e === g._id)
                                ? 'group-selected'
                                : ''
                            }`}
                            onDoubleClick={() => openEditGroup(g)}
                          >
                            <td>
                              <input
                                type="checkbox"
                                className="mr-2"
                                checked={
                                  selectedGroupIds &&
                                  selectedGroupIds.indexOf(g._id) >= 0
                                }
                                onChange={e => onSelectKnowledgeGroup(e, g._id)}
                              />
                            </td>
                            <td>
                              <div
                                className={`d-flex align-items-center tree-p-${g.depth}`}
                              >
                                {isShowExpand(g) && (
                                  <IconButton
                                    className="toggle-icon"
                                    onClick={() => toggleGroup(g)}
                                    size="small"
                                    aria-label={
                                      isExpanded(g._id)
                                        ? t('Collapse group')
                                        : t('Expand group')
                                    }
                                    sx={{ padding: '10px' }}
                                  >
                                    {isExpanded(g._id) ? (
                                      <ExpandMoreIcon fontSize="small" />
                                    ) : (
                                      <ChevronRightIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                )}
                                {!isShowExpand(g) && (
                                  <IconButton
                                    className="toggle-icon"
                                    size="small"
                                    aria-hidden
                                    disableRipple
                                    disableFocusRipple
                                    sx={{
                                      padding: '10px',
                                      visibility: 'hidden',
                                    }}
                                  >
                                    <ChevronRightIcon fontSize="small" />
                                  </IconButton>
                                )}
                                <div className="d-flex flex-1 pl-2">
                                  {g.name}
                                </div>
                              </div>
                            </td>
                            <td>{g?.topic || '-'}</td>
                            <td className="text-center">
                              <div className="edit-actions d-flex justify-content-center">
                                <IconButton
                                  className="btn edit-group ml-1"
                                  onClick={() => openEditGroup(g)}
                                  size="small"
                                  sx={{ padding: '8px' }}
                                  aria-label={t('Edit group')}
                                >
                                  <EditOutlinedIcon
                                    fontSize="small"
                                    color="primary"
                                  />
                                </IconButton>
                                <IconButton
                                  className="add-group"
                                  onClick={() => {
                                    if (isShowExpand(g) && !isExpanded(g._id)) {
                                      toggleGroup(g)
                                    }
                                    openAddGroup(g)
                                  }}
                                  size="small"
                                  sx={{ padding: '8px' }}
                                  aria-label={t('Add subgroup')}
                                >
                                  <AddIcon fontSize="small" color="primary" />
                                </IconButton>
                                <IconButton
                                  className="delete-group ml-1"
                                  onClick={() => {
                                    setDeletedModuleId([g._id])
                                    setDeleteModuleModalShow(true)
                                  }}
                                  size="small"
                                  sx={{ padding: '8px' }}
                                  aria-label={t('Delete group')}
                                >
                                  <DeleteOutlineIcon
                                    fontSize="small"
                                    color="error"
                                  />
                                </IconButton>
                              </div>
                            </td>
                          </tr>
                        ),
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
